<section class="jumbotron">
    <div class="title"><h3>ERBO Engineering</h3></div>
    <div class="spacer"></div>
    <div class="subtitle">Embedded – IoT – App</div>
    <div class="subtitle">Our mission is to help you thrive</div>
    <app-fancy-slice></app-fancy-slice>
  </section>